import type { Company } from '@indutrust/shared-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on Company entities.
 *
 * Manages the complete lifecycle of company data operations:
 * - loadAll, loadById, add, edit, delete
 * Each operation has request, success, and failure variants.
 *
 * Uses 'company' as the event source namespace for Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(companyEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const companyEvents = createCrudEvents<Company>('company');
